<header *ngIf="showHeader" class="stepper-header" [class]="headerClass"
  [style.background-color]="headerBackgroundColor">
  <div class="w-100 d-flex flex-nowrap gap-4">
    <div class="d-flex align-items-center" *ngFor="let step of steps; let i = index;"
      [class.flex-grow-1]="i !== steps.length - 1">
      <div mdbRipple class="d-flex align-items-center gap-2 py-2 px-lg-4 sch-stepper-item"
        [class.disabled]="isStepDisabled(i)" [class.disabled-cursor]="isStepDisabled(i)" (click)="selectStep(i)">
        <p class="sch-stepper-count m-0" [ngClass]="{
             'selected-border-color': isActive(i),
             'selected-stepper-bg': isActive(i),
             'disabled-stepper-bg': isStepDisabled(i)
           }">
          {{i+1}}
        </p>
        <p class="header-label m-0" [ngClass]="{
             'selected-text': isActive(i),
             'disabled-text': isStepDisabled(i)
           }">
          {{step.label ? step.label : 'Step '+(i+1)}}
        </p>
      </div>
      <!-- <hr class="header-line flex-grow-1" [ngClass]="{
          'selected-border-color': isActive(i),
          'selected-stepper-bg': isActive(i),
          'disabled-border-color': isStepDisabled(i)
        }"> -->
    </div>
  </div>
</header>
<ng-container [ngTemplateOutlet]="selected ? selected.content : null"></ng-container>